import { gql } from '@apollo/client'

export const Query = gql`
  query EventItems(
    $companyId: ID!,
    $eventId: ID!,
    $filters: EventItemFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    companies(filters: { idEq: $companyId }) {
      nodes {
        id
        placeholderLogo { id url }
      }
    }
    events(companyId: $companyId, filters: { idEq: $eventId }, first: 1) {
      nodes {
        id
        eventItems(filters: $filters, after: $after, before: $before, first: $first, last: $last) {
          nodes {
            id
            eventStage { id name }
            quantity
            discount
            item {
              ...on AssetType {
                id
                name
                images { id url }
              }
              ...on Package {
                id
                name
                images { id url }
              }
              ...on RowItem {
                id
                name
                images { id url }
              }
              ...on Vehicle {
                id
                name
                images { id url }
              }
            }
          }
          pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
        }
      }
    }
  }
`
